(() => {
  'use strict';
  const registry = new WeakSet();
  function init(node) {
    if (registry.has(node)) return;
    registry.add(node);
    let variants;
    try { variants = JSON.parse(node.querySelector('[data-dobelo-stock-variants]').textContent); }
    catch (_) { return; }
    const byId = new Map(variants.map(variant => [String(variant.id), variant]));
    const main = node.closest('#MainContent') || document;
    const heading = main.querySelector('h1');
    const group = heading?.closest('.shopify-section') || main;
    let form = null;
    for (const candidate of group.querySelectorAll('form[action*="/cart/add"]')) {
      const control = candidate.querySelector('[name="id"]');
      if (control && byId.has(String(control.value))) { form = candidate; break; }
    }
    const nativeNotice = group.querySelector('.zmp__stock,.zs-stock-alert');
    const priceAnchor = group.querySelector('.za-price-box,.zd-price-box,.zf-price-box,.zs-price-box,.zmp__price-wrap,.f60x__price-row,.f60x__price-line,.dsp__price-line,.zdg__price,.zg-price,.product__info-container .price,.product__info-container [id^="price-"]');
    if (nativeNotice && !nativeNotice.contains(node)) {
      nativeNotice.insertAdjacentElement('beforebegin', node);
      nativeNotice.classList.add('dobelo-stock-replaced');
    } else if (priceAnchor && !priceAnchor.contains(node)) {
      priceAnchor.insertAdjacentElement('afterend', node);
    } else if (form && !form.contains(node)) {
      form.insertAdjacentElement('beforebegin', node);
    } else if (heading && node.parentElement !== heading.parentElement) {
      heading.insertAdjacentElement('afterend', node);
    }
    function update(explicitId) {
      const control = form?.querySelector('[name="id"]');
      const candidates = [explicitId, control?.value, new URL(location.href).searchParams.get('variant'), node.dataset.initialVariant];
      const selected = candidates.find(id => id && byId.has(String(id)));
      const variant = byId.get(String(selected));
      if (!variant) return;
      const sold = !variant.available;
      node.hidden = false;
      node.classList.toggle('is-sold-out', sold);
      const title = sold ? 'Wyprzedany' : 'Ostatnie sztuki';
      const subtitle = sold ? 'Obecnie niedostępny' : 'Produkt na wyczerpaniu';
      const titleNode = node.querySelector('[data-dobelo-stock-title]');
      const subtitleNode = node.querySelector('[data-dobelo-stock-subtitle]');
      if (titleNode.textContent !== title) titleNode.textContent = title;
      if (subtitleNode.textContent !== subtitle) subtitleNode.textContent = subtitle;
    }
    function schedule(event) {
      const explicit = event?.detail?.variant?.id || event?.detail?.id;
      requestAnimationFrame(() => update(explicit));
      setTimeout(() => update(explicit), 100);
      setTimeout(() => update(explicit), 350);
    }
    group.addEventListener('change', schedule);
    group.addEventListener('click', schedule);
    document.addEventListener('variant:change', schedule);
    document.addEventListener('variantChange', schedule);
    addEventListener('popstate', schedule);
    if (form) {
      const observer = new MutationObserver(() => update());
      observer.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    }
    update();
  }
  const start = () => document.querySelectorAll('[data-dobelo-stock-notice]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();